import _ from 'lodash';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout, Avatar, Popover, Row, Col, Typography, theme, Flex, Grid } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faAngleDown } from '@fortawesome/free-solid-svg-icons';

import './Header.less';
import LocalStorageHelper from '../../helpers/local_storage';
import sengLogo from '../../images/seng-logo.svg';
import API from '../../helpers/api';

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Header } = Layout;
const { Title, Text } = Typography;

const NavigationHeader  = () => {
	const { token } = useToken();
	const screens = useBreakpoint();
	const history = useHistory();
	const [event, setEvent] = React.useState(null);

	useEffect(async () => {
		const response = await API.event.getPublishedEvent();
		if (response.meta.code !== 200) {
			return;
		}
		setEvent(response.data.event);
	}, [])

	// Other data
	const user = LocalStorageHelper.getUser();
	// const event = LocalStorageHelper.getEvent();
	const avatar = (
		<Avatar
			size="large"
			style={{ backgroundColor: '#96CE56' }}
		>
			{user.email.charAt(0).toUpperCase()}
		</Avatar>
	);

	return (
		<Header className="nav-header">
			<Flex justify="center">
				{
					screens.lg && (
						<>
							<img
								src={sengLogo}
								alt="HKUST Logo"
								style={{ height: 48, marginRight: 30 }}
							/>
						</>
					)
				}
				<Flex align="center">
					<Title
						level={1}
						style={{
							color: token.colorPrimary,
							fontSize: screens.xs ? 16 : 20,
							fontWeight: 590,
							margin: 0,
							maxWidth: 396
						}}
					>
						{_.get(event, 'name') || 'HKUST Engineering Summer Camp Online Application System'}
					</Title>
				</Flex>
			</Flex>
			<Popover
				placement="bottomRight"
				content={
					<>
						<Row>
							<Col>
								{avatar}
							</Col>
							<Col>
								<div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 10 }}>
									<Text
										strong
										style={{ color: token.colorNeutral }}
									>
										{user.last_name}, {user.first_name}
									</Text>
									<Text style={{ marginTop: -5, color: token.colorNeutral }}>{user.email}</Text>
								</div>
							</Col>
						</Row>
						<div
							className="divider"
							style={{ margin: '15px 0px' }}
						/>
						<Row
							justify="space-between"
							style={{ cursor: 'pointer' }}
							onClick={() => history.push('/logout')}
						>
							<Text>Sign Out</Text>
							<FontAwesomeIcon
								icon={faArrowRightFromBracket}
								fixedWidth
							/>
						</Row>
					</>
				}
			>
				<Row
					gutter={6}
					style={{ marginLeft: 30 }}
				>
					<Col>
						{avatar}
					</Col>
					{
						screens.lg && (
							<>
								<Col>
									{user.email}
								</Col>
								<Col>
									<FontAwesomeIcon
										icon={faAngleDown}
										fixedWidth
									/>
								</Col></>
						)
					}
				</Row>
			</Popover>
		</Header>
	);
};

export default NavigationHeader;
